import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Skeleton from '@mui/material/Skeleton';
import clsx from 'clsx';
import Link from 'next/link';
import styles from './styles.module.css';

export default function NewBreadcrumbs({ breadcrumbs = [], isLoading = false }: {breadcrumbs: {name: string; url: string}[]; isLoading?: boolean}) {
  const last = breadcrumbs.length > 0 ? breadcrumbs.length - 1 : 0;

  if (isLoading) {
    return <Skeleton variant="text" width={450} height={25} />;
  }

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
      {breadcrumbs &&
        breadcrumbs.length > 0 &&
        breadcrumbs.map((item, i) =>
          i === last ? (
            <span key={`${item.name}${i}`} className={clsx(styles.item_breadcrumb, styles.last_breadcrumb)}>
              {item.name}
            </span>
          ) : (
            <Link href={item.url} key={`${item.name}${i}`} passHref>
              <a className={styles.item_breadcrumb}>{item.name}</a>
            </Link>
          ),
        )}
    </Breadcrumbs>
  );
}
